import React, { useEffect, useState } from "react";
import { FetchAgencyPlanManagement } from "../../../../api/helper";

function ClientSubscriptionPlan({ info }) {
  const [plans, setPlans] = useState([]);
  const [activeTab, setActiveTab] = useState("biweekly");
  const [activeplan, setactiveplan] = useState([]);

  const fetchData = async () => {
    try {
      const respones = await FetchAgencyPlanManagement(
        info?.agencyIds[0]?._id,
        "subscription"
      );
      setPlans(respones.data.data);
    } catch (error) {
      console.log(error, "===>>");
    }
  };
  useEffect(() => {
    if (info?.agencyIds[0]?._id) {
      fetchData();
    }
  }, []);
  const filterPlansByType = (type) => {
    return plans.filter(
      (plan) => plan.planType.toLowerCase() === type.toLowerCase()
    );
  };
  const switchTab = (tab) => {
    setActiveTab(tab);
  };
  return (
    <>
      <div className="container_subscription">
        <h1>Available Plans</h1>
        <>
          <div
            style={{
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="tabs_MemberPlan">
              {["biweekly", "monthly", "biannually", "annually"].map((tab) => (
                <button
                  key={tab}
                  className={`tab-button_MemberPlan ${
                    activeTab === tab ? "active" : ""
                  }`}
                  onClick={() => switchTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>
          </div>

          {["biweekly", "monthly", "biannually", "annually"].map((tab) => (
            <div
              key={tab}
              className={`plans-container_MemberPlan ${
                activeTab === tab ? "active" : ""
              }`}
            >
              {filterPlansByType(tab).length === 0 ? (
                <div className="no-plans-message_MemberPlan">
                  No {tab.charAt(0).toUpperCase() + tab.slice(1)} Subscription
                  Plan available
                </div>
              ) : (
                filterPlansByType(tab).map((plan) => {
                  const isSubscribed = activeplan.some(
                    (active) => active.planId?._id === plan._id
                  );
                  return (
                    <div key={plan._id} className="plan-card_MemberPlan">
                      {isSubscribed && (
                        <span style={{ color: "Green", fontWeight: "bold" }}>
                          {" "}
                          Active
                        </span>
                      )}
                      <div className="plan-title_MemberPlan">
                        {plan.PlanName}
                      </div>
                      <div className="plan-frequency_MemberPlan">{`Charged ${plan.planType.toLowerCase()}`}</div>
                      <div className="plan-price_MemberPlan">{`$${plan.fee} / ${
                        tab.charAt(0).toUpperCase() + tab.slice(1)
                      }`}</div>
                      <ul className="features_MemberPlan">
                        <li>
                          <i className="fas_MemberPlan fa-user-md" />
                          {plan?.Benefits}
                        </li>
                      </ul>
                      <div className="cta-buttons_MemberPlan">
                        <button
                          className="cta-button_MemberPlan"
                          // onClick={() =>
                          //   openEnrollModal(plan.PlanName, `$${plan.fee}`, plan)
                          // }
                        >
                          Enroll
                        </button>
                        <button
                          className="cta-button_MemberPlan details-button"
                          // onClick={() =>
                          //   openDetailsModal(
                          //     plan.PlanName,
                          //     `$${plan.fee}`,
                          //     plan.planType,
                          //     plan.AddIndividualItems.map((item) => ({
                          //       service: item.item,
                          //       unit: item.count,
                          //     }))
                          //   )
                          // }
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          ))}
        </>
      </div>
    </>
  );
}

export default ClientSubscriptionPlan;
